var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalDelegation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7077_76377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7077_76377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7715 9.20801L7.22982 5.66634L8.41732 4.49967L10.7715 6.85384L15.5007 2.14551L16.6673 3.31217L10.7715 9.20801ZM11.6673 18.7497L5.83398 17.1247V9.16634H7.45898L12.6257 11.083C13.084 11.2497 13.4555 11.5413 13.7402 11.958C14.025 12.3747 14.1673 12.833 14.1673 13.333H12.5007C11.9173 13.333 11.459 13.3122 11.1257 13.2705C10.7923 13.2288 10.5007 13.1663 10.2507 13.083L8.58398 12.5413L8.33398 13.333L9.64648 13.8122C10.0354 13.965 10.3895 14.0622 10.709 14.1038C11.0284 14.1455 11.4034 14.1663 11.834 14.1663H15.834C16.7507 14.1663 17.3965 14.3156 17.7715 14.6143C18.1465 14.9129 18.334 15.3191 18.334 15.833V16.6663L11.6673 18.7497ZM0.833984 18.333V9.16634H4.16732V18.333H0.833984Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalDelegation);
export default __webpack_public_path__ + "static/media/approval_delegation.fe5a3d3a318f651da7cbeca558b19082.svg";
export { ForwardRef as ReactComponent };